import Telemetry from '@atlassian/mpac-telemetry';
import { useEffect } from 'react';
import { setupProductHomepageTask, ViewProductEnterpriseSection, viewProductEnterpriseSectionTask, ViewProductSections, viewProductSectionTask } from './tasks';
export const useProductPageTelemetry = _ref => {
  let {
    productId,
    productInfo,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  } = _ref;
  useEffect(() => {
    const showEnterpriseSection = !!productInfo.showEnterpriseAppsSection;
    const ProductPageTask = setupProductHomepageTask(showEnterpriseSection);
    ProductPageTask.start();
    if (showEnterpriseSection) {
      ViewProductEnterpriseSection.start();
    }
  }, [productId, productInfo.showEnterpriseAppsSection]);
  useEffect(() => {
    if (isEnterpriseAppsSectionLoadError) {
      Telemetry.setUFOInteractionError({
        name: viewProductEnterpriseSectionTask,
        errorMessage: enterpriseAppsSectionDataError
      });
      ViewProductEnterpriseSection.failed(enterpriseAppsSectionDataError);
    }
    if (enterpriseAppsSectionData) {
      ViewProductEnterpriseSection.succeeded();
    }
  }, [isEnterpriseAppsSectionLoadError, enterpriseAppsSectionData, enterpriseAppsSectionDataError]);
  useEffect(() => {
    if (areSectionsLoading) {
      ViewProductSections.start();
    }
    if (isSectionsLoadError) {
      Telemetry.setUFOInteractionError({
        name: viewProductSectionTask,
        errorMessage: sectionsDataError
      });
      ViewProductSections.failed(sectionsDataError);
    }
    if (sectionsData) {
      ViewProductSections.succeeded();
    }
  }, [areSectionsLoading, isSectionsLoadError, sectionsData, sectionsDataError]);
};